// Module
var code = "<svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 32 40\" x=0px y=0px><g data-name=\"Layer 2\"><path stroke=currentColor d=M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm3.5,20H15a1,1,0,0,1,0-2h4.5a2.5,2.5,0,0,0,0-5H11.41l1.29,1.29a1,1,0,1,1-1.41,1.41l-3-3a1,1,0,0,1,0-1.42l3-3a1,1,0,0,1,1.41,1.41L11.41,13H19.5a4.5,4.5,0,0,1,0,9Z /></g></svg>";
// Exports
module.exports = code;